import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { CasoMejoraCU2 } from '../../api/mejoraCU2Api';
import { ESTADO_LABEL, ESTADO_COLOR } from './estados';

interface Props {
  casos: CasoMejoraCU2[];
  loading: boolean;
  onRowClick: (caso: CasoMejoraCU2) => void;
}

const PRIORIDAD_COLOR: Record<string, string> = { Alta: 'red', Media: 'blue', Baja: 'default' };

const CasosTable: React.FC<Props> = ({ casos, loading, onRowClick }) => {
  const columns: ColumnsType<CasoMejoraCU2> = [
    { title: 'Código', dataIndex: 'codigo', key: 'codigo', width: 120 },
    { title: 'Título', dataIndex: 'titulo', key: 'titulo', width: 220, ellipsis: true },
    { title: 'Descripción', dataIndex: 'descripcion', key: 'descripcion', ellipsis: true },
    { title: 'Entidad', key: 'entidad', width: 160, render: (_, r) => `${r.entidadTipo} #${r.entidadRefId}` },
    { title: 'Prioridad', dataIndex: 'prioridad', key: 'prioridad', width: 110,
      render: (p: string) => <Tag color={PRIORIDAD_COLOR[p] ?? 'default'}>{p}</Tag> },
    { title: 'Estado', dataIndex: 'estado', key: 'estado', width: 140,
      render: (e: CasoMejoraCU2['estado']) => <Tag color={ESTADO_COLOR[e]}>{ESTADO_LABEL[e]}</Tag> },
    { title: 'Creado', dataIndex: 'creadoEn', key: 'creadoEn', width: 160,
      render: (v: string) => new Date(v).toLocaleString('es-ES') },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={casos}
      loading={loading}
      pagination={{ pageSize: 20, showSizeChanger: true, showTotal: (t) => `Total: ${t} casos` }}
      onRow={(record) => ({ onClick: () => onRowClick(record), style: { cursor: 'pointer' } })}
    />
  );
};

export default CasosTable;
